import React from 'react';
import PatientQueue from './PatientQueue';
import ChartPreviewModal from "./ChartPreview"
import { connect } from 'react-redux';
import { hideToast, showToast } from "../../actions/common";
import {
    redirectToSearch, getPatientDetail,
    loadPatientDetail, isChartOpen, checkOpenAssociatedChart,
    getOrganizationNote,
    openRpmEnrollmentOnChartLoad,
} from '../../actions/admin';
import { isRpmEnrollerClinicalCenter } from '../../utils';
import { RPM_ADDON_STATUS_ELIGIBLE } from '../../constants/other';

class SearchPatient extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            patientData: null,
            lastNote: ''

        }
    }
    handlePatientPreview = (router) => {
        if (router && router.location && router.location.pathname && router.location.pathname.indexOf("search") !== -1) {
            const id = router.location.query && router.location.query.id;
            const showPreview = localStorage.getItem(`showPreview${id}`);
            if (id && id.trim() && showPreview) {
                this.props.getPatientDetail(id)
                    .then(patientData => {
                        this.setState({ patientData, showModal: true });
                        this.props.getOrganizationNote(patientData.provider.organization_id);
                        localStorage.removeItem(`showPreview${id}`);
                    });
            }
        }
    }

    componentDidMount() {
        const { router } = this.props;
        this.handlePatientPreview(router);
    }

    componentDidUpdate(prevProps) {
        const prevRouter = prevProps.router;
        const nextRouter = this.props.router;
        const prevId = prevRouter && prevRouter.location && prevRouter.location.query && prevRouter.location.query.id;
        const nextId = nextRouter && nextRouter.location && nextRouter.location.query && nextRouter.location.query.id;
        // Run when id changed, or when router/id becomes available after mount (so initial load still triggers API)
        if (nextId !== prevId || (nextId && !prevRouter)) {
            if (this.state.showModal) {
                this.setState({ showModal: false, patientData: null });
            }
            if (nextId) {
                this.handlePatientPreview(nextRouter);
            }
        }
    }


    preventAccess = (charts) => {
        let result_array = charts['result'];
        for (let i = 0; i < result_array.length; i++) {
            if (result_array[i].chart_open) {
                return true
            }
        }
    }

    openRpmEnrollFromLookup = (patient) => {
        window.localStorage.setItem('ccm_queue', 'search');
        window.localStorage.setItem('ccm_queue_user', this.props.activeUser.username);
        this.props.openRpmEnrollmentOnChartLoad(patient.id);
        this.props.loadPatientDetail(patient);
    }

    openChart = () => {
        const patient = this.state.patientData;
        const { activeUser, userRoles } = this.props;
        if (isRpmEnrollerClinicalCenter(activeUser, userRoles)) {
            if (patient.rpm_addon_status_id === RPM_ADDON_STATUS_ELIGIBLE) {
                this.openRpmEnrollFromLookup(patient);
            }
            return;
        }
        window.localStorage.setItem('ccm_queue', 'search');
        window.localStorage.setItem('ccm_queue_user', this.props.activeUser.username);
        if (this.props.activeUser && this.props.activeUser.center && this.props.activeUser.center.ce_flag) {
            this.props.checkOpenAssociatedChart(patient.id)
                .then((result) => {
                    const preventAccess = this.preventAccess(result);
                    if (preventAccess) {
                        this.props.showToast({
                            status: 'error',
                            title: 'Denied',
                            message: 'An associated chart is currently open.',
                        });
                        const interval = setInterval(() => {
                            clearInterval(interval);
                            this.props.hideToast();
                        }, 2);

                    } else {
                        this.props.loadPatientDetail(patient);
                    }
                })
                .catch((e) => {
                    if (e.code !== 'session_timeout') {
                        this.props.showToast({
                            status: 'error',
                            title: 'Failure',
                            message: 'Failed to check associated charts.',
                        });
                        const interval = setInterval(() => {
                            clearInterval(interval);
                            this.props.hideToast();
                        }, 2);
                    }

                });
        } else {
            this.props.loadPatientDetail(patient);
        }
    }

    onHide = () => {
        window.close();
        this.setState({ showModal: false });
    }
    render() {
        const { activeUser, userRoles } = this.props;
        const isRpmEnrollerUser = isRpmEnrollerClinicalCenter(activeUser, userRoles);
        const previewPatient = this.state.patientData;
        const previewRpmEligible = previewPatient
            && previewPatient.rpm_addon_status_id === RPM_ADDON_STATUS_ELIGIBLE;

        return (<div>
            <PatientQueue
                showSearch
                rowHeight={150}
                patientDetailColumn
                providerDetailColumn
                timeBilledColumn
                statusColumn
                statusActionsColumn
                reengageIndicator
                programTypeColumn
                queue="search"
                label="Lookup Patient"
                columnHeaderStyle={{ textAlign: 'center' }}
            />
            <ChartPreviewModal show={this.state.showModal}
                activeUser={this.props.activeUser}
                organizationNote={this.props.organizationNote}
                onHide={this.onHide} patient={this.state.patientData} notes={this.state.lastNote}
                openChart={this.openChart}
                allowRpmEnrollButton={isRpmEnrollerUser}
                rpmEnrollOnlyMode={isRpmEnrollerUser}
                isRpmEligible={previewRpmEligible}
                onRpmEnroll={() => previewPatient && this.openRpmEnrollFromLookup(previewPatient)}
            />
        </div>)
    }

}

export default connect(
    (state, ownProps) =>
    ({
        router: state.router,
        activeUser: state.admin.activeUser,
        selectedPatient: state.app.selectedPatient,
        organizationNote: state.levelTwoDashboard.organizationNote,
        userRoles: state.auth.roles,
    }),
    {
        redirectToSearch,
        getPatientDetail,
        hideToast,
        showToast,
        loadPatientDetail,
        isChartOpen,
        checkOpenAssociatedChart,
        getOrganizationNote,
        openRpmEnrollmentOnChartLoad,
    }
)(SearchPatient)

